module.exports = __webpack_public_path__ + "img/participant-picture-3.4dd0b18.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/participant-picture-3.svg
// module id = 1IYx
// module chunks = 0